import Vue from "vue";
export default {
  convertToQueryString: function(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },
  showSuccessMessage(message) {
    Vue.swal.fire("Success!", message, "success");
  },
  showErrorMessage(message) {
    Vue.swal.fire("Error", message, "error");
  },
  showDialog(title, message) {
    return Vue.swal.fire({
      title: "Information",
      text: message,
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: title
    });
  },
  formatDate(date) {
    return (
      date.getFullYear() +
      "-" +
      this.padtotwodigit(date.getMonth() + 1) +
      "-" +
      this.padtotwodigit(date.getDate())
    );
  },
  padtotwodigit(value) {
    return value < 10 ? "0" + value : value;
  }
};
